import React from 'react';
import { useNavigate } from 'react-router-dom';

// importing Logos
import LogoTT from '../assets/images/LogoTT.png';
import LogoLL from '../assets/images/LogoLL.jpg';

// Imports css for Landing Page
import '../styles/LandingPage.css';

//Import images of phone and laptop
import LaptopImage from '../assets/images/laptop.png';
import PhoneImage from '../assets/images/phone2.png';
import NoteBarScreenshot from '../assets/images/notebar2.png';


const LandingPage = () => {
  const navigate = useNavigate(); // Hook for navigation

  return (
    <div className = "container">

      {/* Header Section with Notebar Logo */}
      <header className = "header">
        <div className = "logo-container">
        <img src={LogoTT} alt="Notebar Logo" className = "logo" />
        </div>

      {/* Navigation Links */}
        <nav className = "nav-links">
          <span onClick={() => navigate('/demo')}>Demo</span>
          <span onClick={() => navigate('/blog')}>Blog</span>
          <span onClick={() => navigate('/news')}>News</span>
          <span onClick={() => navigate('/team')}>Team</span>
          <span onClick={() => navigate('/contact')}>Contact</span>
        </nav>

      {/* Login and SignUp Buttons */}
      <div className = "auth-buttons">
        <button className = "nav-button login" onClick={() => navigate('/login')}>
          Log In
        </button>
        <button className = "nav-button signup" onClick={() => navigate('/signup')}>
          Sign Up
        </button>
      </div>
    </header>

    {/* Headline Above Devices */}
      <h2 className="headline">
      Helping <span className="highlight">College Students🎓</span> accomplish their hopes and dreams.
    </h2>

       {/* Center Content with Laptop and Phone */}
      <div className="center-content">
        <div className="device-container">
          
          <img src={LaptopImage} alt="Laptop" className="laptop-image" />
          <img src={NoteBarScreenshot} alt="Screenshot Inside Laptop" className="logo-overlay laptop-logo" />
        </div>

        <div className="device-container">
          <img src={PhoneImage} alt="Phone" className="phone-image" />
          <img src={LogoLL} alt="Logo Inside Phone" className="logo-overlay phone-logo" />
        </div>
      </div>

      {/* Footer Links */}
      <div className = "footer-links">
        <div>
          <span
            onClick={() => navigate('/terms-and-privacy#terms')}
          >
            Terms of Use
          </span>
          <span> | </span>
          <span
            onClick={() => navigate('/terms-and-privacy#privacy')}
          >
            Privacy Policy
          </span>
        </div>
        <p>
          &copy; 2024 Open Knowledge of New York, LLC. All Rights Reserved.
        </p>
      </div>
    </div>
  );
};

export default LandingPage;
